import React, { Fragment } from 'react'

// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import FormLabel from '@material-ui/core/FormLabel'
import Checkbox from '@material-ui/core/Checkbox'

// @material-ui/icons
import AvTimer from '@material-ui/icons/AvTimer'
import Check from '@material-ui/icons/Check'
import DeleteForever from '@material-ui/icons/DeleteForever'

// core components
import GridContainer from 'components/Grid/GridContainer.jsx'
import GridItem from 'components/Grid/GridItem.jsx'
import DropdownEP from '../Components/DropdownEP'
import DropdownCompanies from '../Components/DropdownCompanies'
import DropdownTypesOfApplication from '../Components/DropdownTypeOfApplication'
import DropdownExpenseType from '../Components/DropdownExpenseType'
import DropdownSigningPath from '../Components/DropdownSigningPath'
import DropdownDepartments from '../Components/DropdownDepartments'
import Card from 'components/Card/Card.jsx'
import CardHeader from 'components/Card/CardHeader.jsx'
import CardIcon from 'components/Card/CardIcon.jsx'
import CardBody from 'components/Card/CardBody.jsx'

import CardActions from '@material-ui/core/CardActions'
import CustomInput from 'components/CustomInput/CustomInput.jsx'
import Button from 'components/CustomButtons/Button.jsx'

// imports for using table layout
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import Paper from '@material-ui/core/Paper'

import extendedFormsStyle from 'assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.jsx'
import AppContext from '../../services/context'

// general api service
import { insertOne, updateOne, retrieveDataUsingGraphQL, retrieveBoundPath, retrieveSomeRoutes, deleteRecord } from '../../services/generalServiceAPI'
import { logger, jsonPP, verifyNumber, noError } from '../utility/utility' //, generateOptionsFromStringArray
import { isEmpty } from 'lodash'

import swal from 'sweetalert2'

// Logic in this module
// 1. tyepOfApplicaiton drives the rendering of the conditions, initial value 9999, when changed, it triggers ConditionPure to render
//    which will fetchData and sent it back via receiveCondition callback where the dataState and data will be updated , thus it triggers
//    main component rerendering.
// 2. the data fetching is trigger via render function, so there will be a warning in the browser, but we check each time if the
//    typeOfApplication has changed, otherwise won't trigger it.
// 3. signingPath will be tied to company dropdown
// 4. when route unditionally, do NOT save conditions
//
// ToDos
// 5. any input fields changes should reset the condition fields
// 6. when id exist, means it's an existing route, should lock everything other than conditions
// 7. Should give level a name and make it a dropdown

// this function is used to create the displayable text in the table, otherwise it's hard to display them field by field
// since the data is too dynamic
function createRow(id, row, noCondition) {
  try {
    logger(`[RoutingDetails][createRow]:`, { row })
    // console.log(isNaN(null), isEmpty(null))
    // console.log(isEmpty(0), isEmpty(5))
    const { routingConditions, signingPath, levelToFinish, unconditionallyRoute } = row
    let desc
    if (unconditionallyRoute) {
      return { id, desc: 'Unconditionally route the application following this path ', path: signingPath.name, level: 'N/A' }
    } else {
      if (isEmpty(routingConditions || isEmpty(signingPath))) throw new Error('Bad route, please check.' + jsonPP(row)) //prevent error reporting, quietly ignore
      desc = routingConditions.reduce((acc, c) => {
        let { type, displayName, minValue, maxValue, value, dropdownId } = c
        switch (type) {
          // null is equal to 1, wtf
          case 'number':
            const maxv = maxValue === null ? 999999999 : maxValue
            const minv = minValue === null ? 0 : minValue
            if (maxv < minv) {
              //ignore maxvalue
              acc = !acc ? `${displayName}>=${minv} ` : `${acc} && ${displayName}>=${minv} `
            } else {
              acc = acc + `${displayName}>=${minv} and <${maxv} `
            }

            // if (isNaN(maxValue)) {
            //   acc = acc + `${displayName}>=${minValue} `
            // } else {
            //   if (maxValue < minValue) {
            //     //ignore maxvalue
            //     acc = !acc ? `${displayName}>=${minValue} ` : `${acc} && ${displayName}>=${minValue} `
            //   } else {
            //     acc = acc + `${displayName}>=${minValue} and <${maxValue} `
            //   }
            // }
            break
          case 'select':
            acc = !acc ? `${displayName}=${dropdownId} ` : `${acc} && ${displayName}=${dropdownId} `
            break
          default:
            acc = !acc ? `${displayName}=${value} ` : `${acc} && ${displayName}=${value} `
        }
        return acc
      }, '')
    }

    // const desc = 'ddd'
    return { id: row.id, desc, path: signingPath.name, level: levelToFinish }
  } catch (e) {
    // error report
    return { id: '', desc: jsonPP(row), path: 'error', level: -1 }
  }
}

// use this function to initialize the conditions fields in data and dataState in this.state
// Only for when there is data passed down from HOC
const initializeDataForConditions = (conditionFields) => {
  let tempArrayForData = []
  conditionFields.map((f, k) => {
    const { name, type, displayName } = f
    switch (type) {
      case 'number':
        // deconstruct to get rid of the junk from graphql
        tempArrayForData.push({
          name,
          type,
          displayName,
          minValue: '',
          maxValue: '',
        })
        break
      case 'select':
        tempArrayForData.push({
          name,
          type,
          displayName,
          dropdownId: '',
        })
        break
      default:
    }
  })
  // console.log(tempArrayForData)
  return tempArrayForData
}
const initializeStateForConditions = (conditionFields) => {
  let tempArrayForState = []
  conditionFields.map((f, k) => {
    switch (f.type) {
      case 'number':
        tempArrayForState.push({
          [f.name + 'minValue']: '',
          [f.name + 'maxValue']: '',
        })
        break
      case 'select':
        tempArrayForState.push({
          [f.name + 'dropdownId']: '',
        })
        break
      default:
    }
  })
  return tempArrayForState
}
class RoutingDesign extends React.Component {
  constructor(props) {
    super(props)

    const initialData = {
      tableName: 'routes',
      typeOfApplication: '',
      typeOfApplicationId: 9999,
      company: {},
      companyId: '',
      departments: [],
      unconditionallyRoute: false,
      signingPath: {},
      expenseType: {},
      levelToFinish: '',
      expenseOrProcurement: '',
      routingConditions: [{}],
    }

    // the data must to be initialized here since render needs them before didMount

    this.state = {
      isThisExistingRoute: false,
      butttonText: 'Add Condition',
      data: initialData,
      dataState: {
        levelToFinish: 'mandatory',
        company: 'error',
        typeOfApplication: 'error',
        signingPath: 'error',
        ...initializeStateForConditions(initialData.routingConditions),
      },
    }

    this.saveCondition = this.saveCondition.bind(this)
    this.needValidation = this.needValidation.bind(this)
    this.handleDropdown = this.handleDropdown.bind(this)
    this.receiveConditions = this.receiveConditions.bind(this)
    this.getLastLevelOfThePath = this.getLastLevelOfThePath.bind(this)
    this.loadFieldsOfConditionsForApplication = this.loadFieldsOfConditionsForApplication.bind(this)
    this.removeFromRoutes = this.removeFromRoutes.bind(this)
  }
  static contextType = AppContext
  loadFieldsOfConditionsForApplication = async (type) => {
    const query = `query TypeOfApplication($id: Int) {
      typeOfApplication(id: $id) {
        id
        name
        fieldsOfCondition {
          type
          name
          displayName
        }
      }
    }`
    if (typeof type === 'undefined') return
    const routingConditions = await retrieveDataUsingGraphQL(query, { id: type })
      .then((response) => {
        if (response.ok) {
          return response.json()
        } else
          return response.json().then((error) => {
            throw new Error(error.errmsg)
          })
      })
      .catch((e) => {
        swal.fire({ title: 'Error', html: e.message, type: 'error' })
      })
    // console.log(routingConditions)
    if (!isEmpty(routingConditions)) {
      const {
        data: {
          typeOfApplication: { fieldsOfCondition },
        },
      } = routingConditions
      return this.receiveConditions(fieldsOfCondition)
    }
  }
  async loadPathInfo() {
    // 1) decide if there is a bound path based upon typeOfApplication (fixed to be 0 for GAT and radio button), companyId (login user), expenseType (user input)
    // 2) if path is bound, retrieve it and report if any error
    // 3) resolve actual signers, report if any error
    const {
      data: { typeOfApplication, company, expenseType, departments, expenseOrProcurement },
    } = this.state

    // isEmpty return true if input is number 0, wth..... :(
    // so instead of making decision on .id, just test on the entire object

    // an application may not need a expensetype such as TO
    if (isEmpty(typeOfApplication) || isEmpty(company.id)) return

    let conditions = { typeOfApplicationId: typeOfApplication.id, companyId: company.id, departments: departments.map((d) => d.value), source: 'addRoute' }

    // 不需要再增加 expenseOrProcurement 条件了， 同样名字 expenseTypeId 已经是唯一而且不同的
    if (!isEmpty(expenseType.value)) conditions = { ...conditions, expenseTypeId: expenseType.value, expenseOrProcurement: expenseOrProcurement.value }
    // 1) retrieve boundPath

    const {
      data: { pathBinding },
    } = await retrieveBoundPath(conditions)

    // 2) resolve signers
    if (!isEmpty(pathBinding)) {
      const {
        data: {
          someRoutes: { routes },
        },
      } = await retrieveSomeRoutes(conditions)
      // console.log('test', pathBinding)
      // console.log('test', routes)
      await this.setState({
        routes,
        data: {
          ...this.state.data,
          departments: pathBinding[0].departments.map((d) => ({ value: d.id, label: d.name })),
          signingPath: {
            id: pathBinding[0].signingPath.id,
            value: pathBinding[0].signingPath.id,
            label: pathBinding[0].signingPath.name,
            numberOfLevels: pathBinding[0].signingPath.numberOfLevels,
          },
          signingPathId: pathBinding[0].signingPath.id,
          unconditionallyRoute: pathBinding[0].unconditionallyRoute,
        },
        dataState: {
          ...this.state.dataState,
          signingPath: 'success',
        },
      })
    } else {
      await this.setState({
        routes: [],
        data: {
          ...this.state.data,
          // signingPath: {},
          // signingPathId: ''
        },
      })
    }
  }
  // every time the typeOfApplication is changed, need to repull condition fields
  receiveConditions = (conditions) => {
    return {
      oldTypeOfApplicationId: this.state.data.typeOfApplicationId,
      data: {
        routingConditions: initializeDataForConditions(conditions),
      },
      dataState: {
        routingConditions: initializeStateForConditions(conditions),
      },
    }
  }
  // for unconditionally route checkout
  // skip conditions if any, directly bind path to the application
  getLastLevelOfThePath() {
    if (this.state.data.unconditionallyRoute && !isEmpty(this.state.associatedPath)) {
      return this.state.associatedPath.signingPath.numberOfLevels
    } else {
      return this.state.data.levelToFinish
    }
  }
  /*
    Decide if unconditional Route existed or not
  */
  isUnconditionalRouteExisted = (routes) => routes.reduce((assumeFalse, route) => assumeFalse || route.unconditionallyRoute, false)
  /*
    Decide if same level Route existed or not, should update instead of insert if so
  */
  isSameLevelRouteExisted = (level) => this.state.routes.reduce((assumeFalse, route) => assumeFalse || route.levelToFinish === level, false)
  async componentDidMount() {
    // data loading logic
    // 1. for new one
    //   1) load pathBinding initially, auto populate path id when both application and company are chosen
    //   2) dynamically load routes when both application and company are chosen
    // 2. for exising one
    //   1) get the specified route and all routes for the same application and company
    //   2) disabling changes other than the level and condistion, so no more dynamica loading needed for associated route
    //   3) when a route is added, route back to list page to get it loaded

    if (this.props.match.path === '/systemadmin/create-route') {
      //  this is for creating new path
      //  need to pull up all the routes for this application in this company once both are chosen
      await this.loadPathInfo()
    } else {
      // means people clicked on the row of table
      // console.log(this.context.route)
      if (this.context.route) {
        const { typeOfApplication, company, departments, signingPath, expenseType, expenseOrProcurement, ...rest } = this.context.route
        this.setState({
          isThisExistingRoute: true,
          oldTypeOfApplicationId: this.context.route.typeOfApplicationId,
          butttonText: 'Update Condition',
          routes: this.context.routes,
          data: {
            ...this.state.data,
            ...rest,
            typeOfApplication: !typeOfApplication ? { label: '' } : { label: typeOfApplication.name },
            company: !company ? { label: '' } : { label: company.name },
            departments: departments.map((d) => ({ label: d.name, value: d.id })),
            signingPath: !signingPath ? { label: '' } : { label: signingPath.name },
            expenseType: !expenseType ? { label: '' } : { label: expenseType.name },
            expenseOrProcurement,
          },
          dataState: {
            ...this.state.dataState,
            company: 'success',
            typeOfApplication: 'success',
            signingPath: 'success',
            // do NOT the following 3 fields to be repopulated again for existing one
            routingConditions: initializeStateForConditions(this.context.route.routingConditions),
          },
        })
      }
    }
  }
  // Dropdown handlers for all
  handleDropdown = (name, key = '') => async (value) => {
    // console.log(name, key, value)
    //isEmpty(key)  doesn't work, any number will result true
    if (key === '') {
      // handle the normal dropdowns other than those in routing conditions

      let fields
      const { data, dataState } = this.state
      // data[`${name}Name`] = value.label
      // do Not remove the following, need it to drive the data fetching, can definitely be fixed
      data[`${name}Id`] = typeof value.id !== 'undefined' ? value.id : value.value
      data[name] = value
      dataState[name] = 'success'
      switch (name) {
        case 'company':
          data['signingPath'] = {}
          data['levelToFinish'] = ''
          data['departments'] = []
          // force the input of level in this case
          dataState['levelToFinish'] = 'error'

          break
        case 'departments':
          // do thing here for now
          // data['departments'] = value
          break
        case 'typeOfApplication':
          // reset a few input values when tyep of application changes

          data['signingPath'] = {}
          data['expenseType'] = {}
          data['expenseOrProcurement'] = {}
          data['levelToFinish'] = ''
          data['departments'] = []
          dataState['levelToFinish'] = 'error'
          fields = await this.loadFieldsOfConditionsForApplication(data.typeOfApplicationId)
          data['routingConditions'] = fields.data.routingConditions
          // this isn't quiet perfect yet
          dataState['routingConditions'] = 'success'
          break
        default:
      }
      // pathBinding returns a list of trucated routes, might be null, so better to make sure it's not empty,

      await this.setState({
        data,
        dataState,
        routingConditions: data['routingConditions'],
        dirty: true,
      })
      await this.loadPathInfo()
    } else {
      // dropdown handler in routing condition

      const { routingConditions } = this.state.data
      // console.log(routingConditions)
      routingConditions[key][name] = value
      this.setState({
        data: {
          ...this.state.data,
          routingConditions,
        },
      })
    }
  }
  handleToggle = async (event) => {
    await this.setState({
      data: {
        ...this.state.data,
        [event.target.name]: !this.state.data[event.target.name],
      },

      dirty: true,
    })
    const l = await this.getLastLevelOfThePath()
    // console.log(l)
    await this.setState({
      data: {
        ...this.state.data,
        levelToFinish: l,
      },
    })
  }
  needValidation = (name, value, order) => {
    if (typeof order !== 'undefined') {
      const { routingConditions, ...rest } = this.state.data
      const rc = routingConditions[order]
      // get the right item in array and modify the value
      rc[name] = value
      // delete old item in array and put the modified back
      routingConditions.splice(order, 1, rc)
      this.setState({
        data: {
          ...rest,
          routingConditions,
        },
        dirty: true,
      })
    } else {
      // this applies to levelToFinish only
      const { signingPath } = this.state.data
      //确保有 numberOfLevels in signingPath
      const allowed = !isEmpty(signingPath) && 'numberOfLevels' in signingPath && Number(value) <= signingPath.numberOfLevels

      if (allowed) {
        // load matching route's condition back to edit field
        const reducedArray = this.state.routes.filter((r) => r.levelToFinish === Number(value))
        this.setState({
          data: {
            ...this.state.data,
            [name]: Number(value),
            routingConditions: reducedArray.length > 0 ? reducedArray[0].routingConditions : this.state.routingConditions,
            id: reducedArray.length > 0 ? reducedArray[0].id : '',
          },
          dataState: {
            ...this.state.dataState,
            [name]: verifyNumber(value) ? 'success' : 'error',
          },
          isThisExistingRoute: reducedArray.length > 0,
          dirty: true,
        })
      }
    }
  }

  removeFromRoutes = (id) => {
    this.setState({ routes: this.state.routes.filter((r) => r.id !== id) })
  }

  async saveCondition() {
    // get clean data, will save the junk in condition fields (type,displayname), but won't use them
    const {
      tableName,
      id,
      typeOfApplicationId,
      companyId,
      departments,
      unconditionallyRoute,
      signingPathId,
      levelToFinish,
      expenseTypeId,
      expenseOrProcurement,
      routingConditions,
      signingPath,
    } = this.state.data

    // 临时修复， 希望能抓到这个bug
    if (isEmpty(signingPathId)) {
      swal.fire({ title: 'Error on routing page', html: 'Please choose a signing path first？！', type: 'error' })
      return
    }
    /*
      Decide if unconditional Route existed or not
      if existed: 
        1. overwrite it if the current is unconditional
        2. warn and refuse to save if the current is conditional
      if non-existed:
        1. if the current is conditional:
          a. same level? warn and overwrite based upon onswer
          b. different level, insert
        2. if the current is unconditional
          a. agree - delete all conditional and insert the unconditonal
          b. disagree - return
    */

    let willOverride = false
    if (!this.state.isThisExistingRoute) {
      // 要加一天无条件路由
      if (unconditionallyRoute) {
        // 如果已经有无条件路由
        if (this.isUnconditionalRouteExisted(this.state.routes)) {
          swal.fire({
            title: 'Warning',
            html: `The signing for the specified application has been set to be routed unconditionally already! no neeed to add another unconditional route.`,
            type: 'warning',
          })
          return
        } else if (!isEmpty(this.state.routes)) {
          // 如果有条件路由
          swal.fire({
            title: 'Warning',
            html: `Please remove all the conditional routes first if you want to route unconditionally for this scenario!`,
            type: 'warning',
          })
          return
        } else {
          // 如果没有路由
        }
      } else {
        if (this.isUnconditionalRouteExisted(this.state.routes)) {
          swal.fire({ title: 'Warning', html: `Are you sure you want to do this, it will override all conditional routes!`, type: 'warning' })
          return
        } else {
          if (this.isSameLevelRouteExisted(levelToFinish)) {
            willOverride = await swal.fire({
              title: 'Warning',
              html: `The same route has been created! please go back to the list to pick it up for editing.`,
              type: 'warning',
            })

            if (!willOverride) {
              return
            }
          }
          if (levelToFinish > signingPath.numberOfLevels) {
            swal.fire({ title: 'Warning', html: `Exceeding the total number of levels for the specified path.`, type: 'warning' })
            return
          }
        }
      }
    }
    const data = {
      tableName,
      // id: willOverride ? this.state.routes.filter(r => r.levelToFinish === levelToFinish)[0].id : id,
      id,
      typeOfApplicationId,
      companyId,
      departments: unconditionallyRoute ? [] : departments.map((d) => d.value),
      unconditionallyRoute,
      signingPathId,
      levelToFinish,
      //expenseTypeId only make sense for type id 1, but leave it in there even for timeoff or other applications to save multiple if/then
      expenseTypeId,
      //saves expsense or procurement as string
      expenseOrProcurement: expenseOrProcurement.value,
      routingConditions,
      creatorId: this.context.user ? this.context.user.id : '',
    }
    if (this.state.dirty) {
      // ignore level to finish when route unconditionally
      // bypassing validtion in case it prevent from being saved
      const { dataState } = this.state
      if (unconditionallyRoute) dataState.levelToFinish = 'success'
      if (noError(dataState)) {
        const insertOrModify = (data) => (data.id ? updateOne(data) : insertOne(data))

        insertOrModify(data)
          .then((response) => {
            // this piece should be able handle exception well now
            if (response.ok) {
              return response.json()
            }
            // return this promise otherwise will get unhandled reject handling error
            // when reponse is not ok, it means something wrong on DB side and the error return in a json
            // only parse out the errmsg here
            else
              return response.json().then((error) => {
                throw new Error(error.errmsg)
              })
          })
          .then((data) => {
            // insertion return id and update return _id, what a mongo
            const recordId = data.id ? data.id : id
            swal.fire({
              title: 'Save route',
              html: 'This record has beend saved - ' + recordId,
              type: 'success',
              timer: 2000,
            })
            // this.props.history.push('/systemadmin/list-routes')
            retrieveSomeRoutes({
              typeOfApplicationId,
              companyId,
              expenseOrProcurement: typeOfApplicationId === 0 ? expenseOrProcurement.value : 'na',
              expenseTypeId,
              departments: unconditionallyRoute ? [] : departments.map((d) => d.value),
            }).then(
              ({
                data: {
                  someRoutes: { pages, routes },
                },
              }) => {
                this.setState({
                  routes,
                  isThisExistingRoute: true,
                  data: {
                    ...this.state.data,
                    id: recordId,
                  },
                })
              }
            )
          })
          .catch((e) =>
            swal.fire({
              title: 'Saving route',
              html: `General API throw error: ${e}`,
              type: 'error',
            })
          )
      } else {
        swal.fire({
          title: 'Saving route',
          html: 'Please fix the error on the page first.',
          type: 'error',
        })
      }
    }
  }
  render() {
    const { classes } = this.props

    return (
      <div style={{ overlow: 'hidden', padding: '0px 20px' }}>
        {/* {this.state.data.typeOfApplicationId != 9999 && this.state.oldTypeOfApplicationId != this.state.data.typeOfApplicationId ? (
          <Conditions typeOfApplicationId={this.state.data.typeOfApplicationId} receiveConditions={this.receiveConditions} />
        ) : (
          ''
        )} */}

        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <Card>
              <CardHeader color='rose' icon>
                <CardIcon color='rose'>
                  <AvTimer />
                </CardIcon>
                <h4 className={classes.cardIconTitle}>Routing Design</h4>
              </CardHeader>
              <CardBody>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                    <GridContainer>
                      <GridItem xs={12} sm={6} md={3}>
                        <DropdownCompanies
                          id='company'
                          isDisabled={this.state.isThisExistingRoute}
                          onChange={this.handleDropdown('company')}
                          loose
                          value={this.state.data.company.label}
                        />
                      </GridItem>
                      <GridItem xs={12} sm={6} md={3}>
                        <DropdownTypesOfApplication
                          id='typeOfApplicationId'
                          formControlProps={{
                            fullWidth: true,
                          }}
                          loose
                          isDisabled={this.state.isThisExistingRoute}
                          value={this.state.data.typeOfApplication}
                          onChange={this.handleDropdown('typeOfApplication')}
                        />
                      </GridItem>

                      <GridItem xs={12} sm={6} md={2}>
                        {this.state.data.typeOfApplicationId === 0 ? (
                          <DropdownEP
                            id='expenseOrProcurement'
                            formControlProps={{
                              fullWidth: true,
                            }}
                            loose
                            value={this.state.data.expenseOrProcurement}
                            isDisabled={this.state.isThisExistingRoute}
                            placeholder={'Select Type'}
                            onChange={this.handleDropdown('expenseOrProcurement')}
                          />
                        ) : (
                          <Fragment />
                        )}
                      </GridItem>
                      <GridItem xs={12} sm={6} md={4}>
                        {this.state.data.typeOfApplicationId === 0 ? (
                          <DropdownExpenseType
                            id='expenseType'
                            formControlProps={{
                              fullWidth: true,
                            }}
                            loose
                            subType={typeof this.state.data.expenseOrProcurement === 'string' ? 'not-set-yet' : this.state.data.expenseOrProcurement.value}
                            isDisabled={this.state.isThisExistingRoute}
                            value={this.state.data.expenseType.label}
                            onChange={this.handleDropdown('expenseType')}
                          />
                        ) : (
                          <Fragment />
                        )}
                      </GridItem>
                    </GridContainer>
                    {/* justify={'flex-end'} */}

                    <GridContainer>
                      <GridItem xs={12} sm={6} md={9}>
                        <DropdownDepartments
                          id='departments'
                          loose
                          isDisabled={this.state.isThisExistingRoute || this.state.data.typeOfApplicationId > 0}
                          companyId={this.state.data.company ? this.state.data.company.id : ''}
                          value={this.state.data.departments}
                          isMulti
                          onChange={this.handleDropdown('departments')}
                        />
                      </GridItem>
                      <GridItem xs={12} sm={6} md={3}>
                        <DropdownSigningPath
                          id='signingPathId'
                          formControlProps={{
                            fullWidth: true,
                          }}
                          companyId={this.state.data.company.id}
                          loose
                          // 能找到一条路由， 说明这个路径已经用了，就不再可编辑
                          isDisabled={this.state.isThisExistingRoute || !isEmpty(this.state.routes)}
                          value={this.state.data.signingPath}
                          onChange={this.handleDropdown('signingPath')}
                        />
                      </GridItem>
                    </GridContainer>

                    <GridContainer>
                      <GridItem xs={12} sm={6} md={6}>
                        <div className={classes.checkboxAndRadio}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                tabIndex={-1}
                                checked={this.state.data.unconditionallyRoute}
                                disabled={this.state.isThisExistingRoute}
                                name='unconditionallyRoute'
                                onClick={(e) => this.handleToggle(e)}
                                checkedIcon={<Check className={classes.checkedIcon} />}
                                icon={<Check className={classes.uncheckedIcon} />}
                                classes={{
                                  checked: classes.checked,
                                  root: classes.checkRoot,
                                }}
                              />
                            }
                            classes={{
                              label: classes.label,
                            }}
                            label='Route unconditionally'
                          />
                        </div>
                      </GridItem>
                      <GridItem xs={12} sm={6} md={6}>
                        {/*  do not need to display level to finish when route unditionally */}
                        {this.state.data['unconditionallyRoute'] ? (
                          <Fragment />
                        ) : (
                          <CustomInput
                            success={this.state.dataState['levelToFinish'] === 'success'}
                            error={this.state.dataState['levelToFinish'] === 'error'}
                            labelText='Level to finish'
                            name='levelToFinish'
                            formControlProps={{
                              fullWidth: true,
                            }}
                            inputProps={{
                              // disabled: this.state.isThisExistingRoute || (this.state.data.unconditionallyRoute && !isEmpty(this.state.data.signingPath.id)),
                              disabled: this.state.data.unconditionallyRoute && !isEmpty(this.state.data.signingPath.id),
                              value: this.state.data.levelToFinish,
                              onChange: (event) => this.needValidation('levelToFinish', event.target.value),
                              type: 'text',
                            }}
                          />
                        )}

                        {/* <GridItem xs={12} md={2} /> */}
                      </GridItem>
                    </GridContainer>
                    <GridContainer className={classes.conditionRoot}>
                      {!this.state.data.unconditionallyRoute && this.state.data.routingConditions.length > 0
                        ? this.state.data.routingConditions.map((field, key) => {
                            if (!isEmpty(field)) {
                              switch (field.type) {
                                case 'number':
                                  return (
                                    <GridContainer key={'container' + key}>
                                      <GridItem key={'grid-of-label' + key} xs={12} md={3}>
                                        <FormLabel key={'label' + key} style={{ textAlign: 'right' }} className={classes.labelHorizontal}>
                                          <b>{field.displayName + ' between '}</b>
                                        </FormLabel>
                                      </GridItem>
                                      <GridItem key={'grid-of-min' + key} xs={12} md={2}>
                                        <CustomInput
                                          success={this.state.dataState.routingConditions[field.name + 'MinValue'] === 'success'}
                                          error={this.state.dataState.routingConditions[field.name + 'MinValue'] === 'error'}
                                          key={'min' + key}
                                          labelText='Min Value'
                                          id={`minValue`}
                                          formControlProps={{
                                            fullWidth: true,
                                          }}
                                          inputProps={{
                                            disabled: false,
                                            value:
                                              this.state.data.routingConditions[key].minValue === null ? ' ' : this.state.data.routingConditions[key].minValue,
                                            onChange: (event) => this.needValidation(event.target.id, event.target.value, key),
                                            type: 'text',
                                          }}
                                        />
                                      </GridItem>
                                      <GridItem key={'grid-of-and' + key} xs={12} md={1}>
                                        <FormLabel key={'label-of-and' + key} className={classes.labelHorizontal}>
                                          <b>{' and '}</b>
                                        </FormLabel>
                                      </GridItem>
                                      <GridItem key={'grid-of-max' + key} xs={12} md={2}>
                                        <CustomInput
                                          success={this.state.dataState.routingConditions[field.name + 'MaxValue'] === 'success' || false}
                                          error={this.state.dataState.routingConditions[field.name + 'MaxValue'] === 'error' || false}
                                          key={'max' + key}
                                          labelText='Max Value'
                                          id={`maxValue`}
                                          formControlProps={{
                                            fullWidth: true,
                                          }}
                                          inputProps={{
                                            disabled: false,
                                            value:
                                              this.state.data.routingConditions[key].maxValue === null ? ' ' : this.state.data.routingConditions[key].maxValue,
                                            onChange: (event) => this.needValidation(event.target.id, event.target.value, key),
                                            type: 'text',
                                          }}
                                        />
                                      </GridItem>
                                    </GridContainer>
                                  )
                                case 'select':
                                  return (
                                    <GridContainer key={'container' + key}>
                                      <GridItem xs={12} md={3}>
                                        <FormLabel key={'select' + key} className={classes.labelHorizontal}>
                                          <b>{field.displayName + ' = '}</b>
                                        </FormLabel>
                                      </GridItem>
                                      <GridItem xs={12} md={4}>
                                        <DropdownDepartments
                                          id='department'
                                          loose
                                          companyId={this.state.data.company ? this.state.data.company.id : ''}
                                          value={this.state.data.routingConditions[key][field.name]}
                                          onChange={this.handleDropdown('department', key)}
                                        />
                                      </GridItem>
                                    </GridContainer>
                                  )
                                case 'text':
                                  return (
                                    <GridContainer>
                                      <GridItem xs={12} md={3}>
                                        <FormLabel key={'eeee' + key} className={classes.labelHorizontal}>
                                          <b>{field.displayName + ' should be the '}</b>
                                        </FormLabel>
                                      </GridItem>
                                      <GridItem xs={12} md={2} />
                                    </GridContainer>
                                  )
                                default:
                                  return logger('[RouteingDetails][render]:', `invalid condition field type ${field.type}`, true)
                              }
                            }
                          })
                        : ''}
                    </GridContainer>
                  </GridItem>
                </GridContainer>
              </CardBody>
              <CardActions>
                <Button color='rose' style={{ marginLeft: 'auto' }} onClick={this.saveCondition}>
                  {this.state.isThisExistingRoute ? 'Update Condition' : 'Add Condition'}
                </Button>
              </CardActions>
            </Card>
          </GridItem>
        </GridContainer>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <Card>
              <CardBody>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                    <legend>All Related Conditions</legend>
                    <GridContainer>
                      <GridItem xs={12} sm={6} md={12}>
                        <Paper className={classes.tableRoot}>
                          <Table className={classes.table}>
                            <TableHead>
                              <TableRow>
                                <TableCell className={classes.tableHeader} colSpan={1}>
                                  No.
                                </TableCell>
                                <TableCell className={classes.tableHeader} colSpan={4}>
                                  Level
                                </TableCell>
                                <TableCell className={classes.tableHeader} colSpan={9}>
                                  Conditions to meet
                                </TableCell>
                                <TableCell className={classes.tableHeader} colSpan={4}>
                                  Path
                                </TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {/* {fields.tableData.map(row => { */}
                              {!isEmpty(this.state.routes) ? (
                                this.state.routes
                                  .map((row, id) => createRow(id + 1, row, this.state.data.unconditionallyRoute))
                                  .sort((a, b) => a.level - b.level)
                                  .map((row) => {
                                    return (
                                      <TableRow key={row.id}>
                                        <TableCell className={classes.tableCell} colSpan={1}>
                                          <Button
                                            justIcon
                                            round
                                            simple
                                            onClick={async (e) => {
                                              await deleteRecord({ id: row.id, tableName: 'routes', refetch: this.removeFromRoutes(row.id) })
                                            }}
                                            color='primary'
                                          >
                                            <DeleteForever className={classes.icon} />
                                          </Button>
                                        </TableCell>
                                        <TableCell className={classes.tableCell} colSpan={4}>
                                          {row.level}
                                        </TableCell>
                                        <TableCell className={classes.tableCell} colSpan={9}>
                                          {row.desc}
                                        </TableCell>
                                        <TableCell className={classes.tableCell} colSpan={4}>
                                          {row.path}
                                        </TableCell>
                                      </TableRow>
                                    )
                                  })
                              ) : (
                                <Fragment />
                              )}
                            </TableBody>
                          </Table>
                        </Paper>
                      </GridItem>
                    </GridContainer>
                  </GridItem>
                </GridContainer>
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
        {jsonPP(this.state)}
      </div>
    )
  }
}

export default withStyles(extendedFormsStyle)(RoutingDesign)
